var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourseFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21.5,
    r: 15.75,
    fill: "#FAE3E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1299 15.8066L22.4355 21.501L28.1299 27.1953L26.6943 28.6309L21 22.9365L15.3057 28.6309L13.8701 27.1953L19.5645 21.501L13.8701 15.8066L15.3057 14.3711L21 20.0654L26.6943 14.3711L28.1299 15.8066Z",
    fill: "#B00020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseFailed);
export default __webpack_public_path__ + "static/media/course-failed.4ce6914c237a89fb1a75d3e9969b2649.svg";
export { ForwardRef as ReactComponent };